import api, { transformCursorResponse, transformRequest } from "services/api";

const debtorProfileAPI = api
  .enhanceEndpoints({ addTagTypes: ["Debtors", "DebtorPacketedDebtors"] })
  .injectEndpoints({
    endpoints: (build) => ({
      createDebtorPacket: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtor-packets/create/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        invalidatesTags: [{ type: "Debtors", id: "LIST" }],
      }),
      linkDebtor: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtor-packets/${payload.debtorPacketId}/debtors/link/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        invalidatesTags: [{ type: "Debtors", id: "LIST" }],
      }),
      unlinkDebtor: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtor-packets/${payload.debtorPacketId}/debtors/unlink/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        invalidatesTags: [{ type: "Debtors", id: "LIST" }],
      }),
      updatePacketMainDebtor: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtor-packets/${payload.debtorPacketId}/update/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        invalidatesTags: [{ type: "Debtors", id: "LIST" }],
      }),
      fetchDebtors: build.query({
        query: (payload) => ({
          url: "/api/v1/core/debtors/",
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformCursorResponse(response),
        providesTags: (response) =>
          response?.results
            ? [
                ...response.results.map(({ id }) => ({ type: "Debtors", id })),
                { type: "Debtors", id: "LIST" },
              ]
            : [{ type: "Debtors", id: "LIST" }],
      }),
      fetchDebtorPacketedDebtors: build.query({
        query: (payload) => ({
          url: `/api/v1/core/debtors/${payload.debtorId}/packeted-debtors/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformCursorResponse(response),
        providesTags: (response, error, arg) =>
          response?.results
            ? [{ type: "DebtorPacketedDebtors", id: arg.debtorId }]
            : [{ type: "DebtorPacketedDebtors", id: arg.debtorId }],
      }),
    }),
  });

export const {
  useCreateDebtorPacketMutation,
  useLinkDebtorMutation,
  useUnlinkDebtorMutation,
  useLazyFetchDebtorsQuery,
  useFetchDebtorsQuery,
  useFetchDebtorPacketedDebtorsQuery,
  useUpdatePacketMainDebtorMutation,
} = debtorProfileAPI;
